import {
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAILURE,
} from '../ActionType';

export const getCurrentUser = (state) => ({
  ...state.user,
});

export default function (
  state = { data: null, loading: true, error: '' },
  action
) {
  switch (action.type) {
    case LOAD_USER_REQUEST: {
      return {
        data: null,
        loading: true,
        error: '',
      };
    }
    case LOAD_USER_SUCCESS: {
      const { user } = action.payload;
      if (!user) {
        return {
          ...state,
          loading: false,
          error: '',
          data: null,
        };
      }
      return {
        ...state,
        data: {
          ...state.data,
          ...user,
        },
        loading: false,
        error: '',
      };
    }
    case LOAD_USER_FAILURE: {
      const { error } = action.payload;
      return {
        data: null,
        loading: false,
        error: error,
      };
    }
    default:
      return state;
  }
}
